import { DataType } from './../enums/data-types';

export const typeToCuikIconRef = new Map<string, any>([
  [DataType.STRING, { icon: 'string', tooltip: 'String', color:'Plum' }],
  [DataType.NUMBER, { icon: 'integer', tooltip: 'Number' , color: 'Pineapple' }],
  [DataType.BOOLEAN, { icon: 'boolean', tooltip: 'Boolean', color: 'Raspberry' }],
  [DataType.DATE, { icon: 'calendarDate', tooltip: 'Date', color:'Tangerine' }],
  [DataType.DATE_TIME, { icon: 'calendar', tooltip: 'Date', color:'Tangerine' }],
  [DataType.AUDIENCE_LIST, { icon: 'list', tooltip: 'Audience List', color: 'Watermelon' }],
  [DataType.INCLUDE_ICON, { icon: 'userProfile', customClass:'includeIconDefinition' }],
  [DataType.EXCLUDE_ICON, { icon: 'userProfile', customClass:'excludeIconDefinition' }],
  [
    DataType.AUDIENCE_DEFINITION,
    { icon: 'user', tooltip: 'Audience Definition', color:'Coconut' },
  ],
  ['default', { icon: 'xFourCornerBorder', tooltip: 'Not Found' }],
]);
